import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { dataDecrypt, dataEncrypt } from "../app/utils/encryption-helper";
import { ApisService } from "../app/core/apis.service";
import vyaparLogo from "../../src/assets/images/vyapar_live_main_logo.png";
import { formatDateTimeInIST } from "../components/indiaDateFormate";

export const RetailView = () => {
  const routerParams = useParams();
  const [loading, setLoading] = useState(false); 
  const [invoiceData, setInvoiceData] = useState<any>([]);
  const [paramInvoice, setParamInvoice] = useState<any>([]);
  const navigate = useNavigate();

  useEffect(() => {
    const reqPayload = routerParams.id as string;
    const decryptdata: any = JSON.parse(dataDecrypt(reqPayload));
    loadInvoice(decryptdata.invoice);
  }, [routerParams]);

  async function loadInvoice(invoiceId:string): Promise<void> {
    setLoading(true);
    try {
      const reqPayload = routerParams.id as string;
      const decryptdata: any = JSON.parse(dataDecrypt(reqPayload));
      let payload = {
        buyerId: decryptdata.buyerId,
        sellerId: decryptdata.sellerId,
        filter: {
          DateFrom: null,
          DateTo: null,
        },
      };
      const EncryptData = dataEncrypt(JSON.stringify(payload));
      const res = await ApisService.getRetailInvoice("getInvoices", EncryptData);
      const data: any = res.data.data;
      setLoading(false);
      const transactionData = JSON.parse(dataDecrypt(data));
      setInvoiceData(transactionData);
      const filterInvoice = transactionData?.results?.filter((el: any) => el._id === invoiceId);
      setParamInvoice(filterInvoice);
    } catch (error) {
      console.error("Error in transaction:", error);
      setLoading(false);
    }
  }

  const getInvoiceDetails = () => {
    navigate(`/retail-view/${routerParams.id}`);
  };

  const getInvoiceData = () => {
    if (paramInvoice[0]?._id) {
      navigate(`/retail/info/${paramInvoice[0]?._id}`);
    }
  };

  return (
    <div className="container py-4">
      {/* Header */}
      {invoiceData?.results && (
        <h2 className="text-center fw-bold primary-color mb-4">
          {paramInvoice[0]?.buyer?.name} Invoice
        </h2>
      )}

      {/* Seller Info */}
      <div className="row align-items-center mb-4 g-3">
        {paramInvoice?.length > 0 && (
          <div className="col-12 col-md-8 text-center text-md-start">
            <div className="fw-semibold fs-5">{paramInvoice[0]?.seller?.name}</div>
            <div className="text-muted small">
              {paramInvoice[0]?.seller?.address?.plot_no && <span>{paramInvoice[0]?.seller?.address?.plot_no},{" "}</span>}
              {paramInvoice[0]?.seller?.address?.buildinghousenumber &&<span>{paramInvoice[0]?.seller?.address?.buildinghousenumber},{" "}</span>}
              {paramInvoice[0]?.seller?.address?.buildingstreetname && <span>{paramInvoice[0]?.seller?.address?.buildingstreetname}</span>}
            </div>
            <div className="text-muted small">
              {paramInvoice[0]?.seller?.address?.villagetowncity && <span>{paramInvoice[0]?.seller?.address?.villagetowncity},{" "}</span>}
              {paramInvoice[0]?.seller?.address?.state && <span>{paramInvoice[0]?.seller?.address?.state},{" "}</span>}
              {paramInvoice[0]?.seller?.address?.postcode && <span>{paramInvoice[0]?.seller?.address?.postcode} </span>}
            </div>
            {paramInvoice[0]?.seller?.mobile_number && <div className="mt-1 fw-semibold small">
              📞 {paramInvoice[0]?.seller?.mobile_number}
            </div>}
          </div>
        )}

        <div className="col-12 col-md-4 text-center text-md-end">
          <img
            src={vyaparLogo}
            alt="Vyapar Logo"
            className="img-fluid"
            style={{ maxWidth: "150px" }}
          />
        </div>
      </div>

      <div className="mx-1">
        {loading && (
          <div className="text-center my-4">
            <div className="spinner-border text-primary" role="status"></div>
          </div>
        )}

        {!loading && paramInvoice?.length > 0 && (
          <>
            <div className="card box-shadow mb-3 border-0 rounded-4">
              <div className="card-body py-3">
                <div className="row text-center gy-3">
                  <div className="col-6 col-md-3 border-md-end">
                    <div className="fw-bold">Invoice Date</div>
                    <div className="text-muted small">
                      {formatDateTimeInIST(
                        paramInvoice[0]?.invoice_details?.invoice_date
                      )}
                    </div>
                  </div>
                  <div className="col-6 col-md-3 border-md-end">
                    <div className="fw-bold">Invoice No</div>
                    <div className="text-muted small">
                      {paramInvoice[0]?.invoice_number}
                    </div>
                  </div>
                  <div className="col-6 col-md-3 border-md-end">
                    <div className="fw-bold">Invoice Amount</div>
                    <div className="text-success fw-semibold">
                      ₹ {paramInvoice[0]?.invoice_details?.invoice_amount}
                    </div>
                  </div>
                  <div className="col-6 col-md-3">
                    <div className="fw-bold">Total Products</div>
                    <div className="text-muted small">
                      {paramInvoice[0]?.invoice_details?.products?.length}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="text-center mb-3">
              <button
                className="btn primary-background px-5 py-2 rounded-4 w-100 w-md-auto"
                onClick={getInvoiceData}
              >
                Open Invoice
              </button>
            </div>

            <div
              className="text-center text-primary fw-bold cursor-pointer"
              onClick={getInvoiceDetails}
            >
              <ins>Previous Invoice Details</ins>
            </div>
          </>
        )}
      </div>
    </div>
  );
};
